// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last ADD : Added Comment Lines
// MODIFIED DATE: 07-12-2025

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

// Get Demand Followup List Start
export const demandFollowupListGet = (listData: any) => {
	const data = {
		DemandFollowupReportToken: listData,
	};
	const url = `${API_URL}getDemandFollowUp`;

	return makeApiCall(url, data);
};
// Get Demand Followup List End
